// extracted by mini-css-extract-plugin
export var sliderRange = "_n6-2";
export var sliderRoot = "_n6-0";
export var sliderThumb = "_n6-3";
export var sliderTrack = "_n6-1";